import { actions } from '@/modules/DocumentReglementaire/store/actions';
import { getters } from '@/modules/DocumentReglementaire/store/getters';
import { mutations } from '@/modules/DocumentReglementaire/store/mutations';
import { state } from '@/modules/DocumentReglementaire/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { DocumentReglementaireState } from './state';

const module: Module<DocumentReglementaireState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { DocumentReglementaireState };
